module.exports = __webpack_public_path__ + "static/media/ufsc.6a24f398.jpeg";